/** @format */
import React, { useEffect, useRef, useState, useCallback } from "react";
import { styled, useTheme } from '@mui/material/styles';
import { Box, Toolbar, Typography, Divider, Button, debounce } from '@mui/material';
import { Viewer, Worker, ScrollMode, SpecialZoomLevel } from '@react-pdf-viewer/core';
import { thumbnailPlugin } from '@react-pdf-viewer/thumbnail';

import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/thumbnail/lib/styles/index.css';

import { useOutletContext, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../Loader";
import { uploadDocument } from "../../store/reducers/uploadDocumentSlice";
import '../../components/Documents/previewer.css';
import { useLogger } from "../../hooks/useLogger";

const TemplatePdfPreview = ({ previewDoc, setPreviewDoc, previewDocument, setPreviewDocument }) => {
  const logEvent = useLogger();
  const { open } = useOutletContext();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const { pdfEditortoken } = useSelector((state) => state.pdfEditortoken);
  
  const thumbnailPluginInstance = thumbnailPlugin({
    renderThumbnailItem: (props) => {
      const isActive = props.pageIndex === props.currentPage;

      return (
          <div
              style={{
                  margin: '4px',
                  border: isActive ? '2px solid #3b82f6' : '1px solid #ccc',
                  borderRadius: '8px',
                  padding: '4px',
                  backgroundColor: isActive ? '#e0f2fe' : '#fff',
                  cursor: 'pointer',
                  transition: 'all 0.2s',
              }}
              onClick={props.onJumpToPage}
          >
              {props.renderPageThumbnail()}
          </div>
      );
    },
  });
  function uploadFileFromUrl() {
    logEvent('Clicked', 'Use Template Clicked', 'Documents/Template');
    fetch(previewDoc?.document_url)
      .then(response => response.blob())
      .then(blob => {
          const file = new File([blob], "uploadedFile.pdf", { type: blob.type });
          dispatch(uploadDocument({ token: pdfEditortoken?.access, file, fileName: previewDoc?.document_name }));
          navigate("/esign/new-esign", { replace: true });
      })
      .catch(error => console.error("Error fetching file:", error));
  }

  return (<>
    <Box
      sx={{
        flexGrow: 1,
        width: "100%",
        transition: "margin 0.3s ease",
        height: "calc(100% - 0px)",
        display: "flex",
        position: "absolute",
        top: 0,
        left: 0,
        p: 2,
        background: "#ffffff",
        zIndex: 9999,
        
      }}
    >
      <Box sx={{ display: "flex", width: "100%", height: "100%", borderRadius: "12px", p: "8px", background: "#ffffff" }}>
        <Box
          sx={{
            width: "200px",
            height: "100%",
            overflowY: "hidden",
            overflowX: "hidden",
            background: "#fff",
            p: 1,
          }}
        >
          <thumbnailPluginInstance.Thumbnails />
        </Box>
        <Box sx={{width: "80%",}}>
          <Box
            sx={{
              flexGrow: 1,
              textAlign: "center",
              background: "#f4f4f4",
              width: "100%",
              height: "calc(100% - 73px)",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              overflowY: "auto",
              p: 2,
              overflowX: "hidden",
              borderRadius: "20px"
            }}
          >
            <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                <Viewer
                    fileUrl={previewDoc?.document_url}
                    defaultScale={SpecialZoomLevel.PageFit}
                    scrollMode={ScrollMode.Vertical}
                    plugins={[thumbnailPluginInstance]}
                />
            </Worker>

          </Box>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", height: "calc(100% - 468px)" }}>
            <Typography noWrap component="p" sx={{ fontSize: '20px', fontWeight: 600, lineHeight: '20px', color: "#1D1D1D", ml: 2 }}>
                {previewDoc?.document_name?.length > 20 ? previewDoc?.document_name.slice(0, 20) + "..." : previewDoc?.document_name}
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "space-between", gap: "20px"}}>
                <Button variant="contained" sx={{ width: '140px', height: 45, color: "#1D1D1D", background: "transparent", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #D2D2D2", boxShadow: "none", fontWeight: "6900",}}  onClick={() => setPreviewDocument(false)} >
                    Cancel
                </Button>
                <Button variant="contained" sx={{ width: '255px', height: 45, color: "#ffffff", background: "#185CB7", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #185CB7", boxShadow: "none", fontWeight: "600", "&:disabled": {background: "#E4E4E4", color: "#ffffff", borderColor: "#E4E4E4"}, "&:hover": {background: "#185CB7", color: "#ffffff", borderColor: "#185CB7"} }} onClick={uploadFileFromUrl} >
                    Use as Template for eSign
                </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
    {loader && <Loader />}
    </>
  );
};

export default TemplatePdfPreview;
